import { useCallback, useEffect, useRef } from 'react'

export const useOverlayResize = <T extends HTMLElement = HTMLDivElement>() => {
  const elementRef = useRef<T>(null)
  const isResizing = useRef(false)
  const transition = useRef<string | undefined>(undefined)

  const handleMouseDown = useCallback(() => {
    isResizing.current = true
    document.body.style.cursor = 'row-resize'

    if (!elementRef.current) return
    transition.current = elementRef.current.style.transition
    elementRef.current.style.transition = 'none'
  }, [])

  useEffect(() => {
    const handleMouseUp = () => {
      isResizing.current = false
      document.body.style.cursor = ''

      if (!elementRef.current) return

      elementRef.current.style.transition = transition.current ?? ''
      transition.current = undefined
    }
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResizing.current || !elementRef.current) return
      e.preventDefault()

      const height = window.innerHeight - e.clientY
      const vh = (height / window.innerHeight) * 100
      elementRef.current.style.height = `${vh.toFixed(2)}vh`
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousemove', handleMouseUp)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [])

  return [elementRef, handleMouseDown] as const
}
